import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateAgoPipe } from '@shared/pipes/date-ago.pipe';
import { AuQuickSearchNamePipe } from '@shared/pipes/quick-search.pipe';

@NgModule({
	imports: [CommonModule, DateAgoPipe, AuQuickSearchNamePipe],
	exports: [DateAgoPipe, AuQuickSearchNamePipe],
})
export class AuPipesModule {}
